function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEditVariant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.56 4.928a1.502 1.502 0 010 2.124L19.48 8.133l-1.062-1.06L19.5 5.99l-2.99-2.99-1.082 1.081-1.06-1.06 1.081-1.082a1.5 1.5 0 012.124 0l2.988 2.988zM5.716 14.194l2.59 2.59-3.33.74.74-3.33zm3.851 1.73l-2.99-2.991 6.728-6.73 2.991 2.991-6.729 6.73zm8.85-6.73l-1.06-1.06-4.047-4.049-.004-.002-8.846 8.845L3 19.5l6.572-1.46 8.846-8.846zM21 22.5H3V21h18v1.5z",
    fill: props.color
  }));
}

export default SvgIconEditVariant;